import React from "react";

interface IProductDescriptionProps {
    description: string;
}

const ProductDescription = ({ description }: IProductDescriptionProps) => {
    return (
        <div className="product-details__description">
            <div className="content-rich-text" dangerouslySetInnerHTML={{ __html: description }} />
        </div>
    );
};

export default ProductDescription;
